export default __webpack_public_path__ + "static/media/1253.a3886918.png";